import { NewsIcon } from '#app/components/icons'

export default {
	name: 'Media Citation',
	slug: 'mediaCitation',
	description: 'Import a Media Citation using its URL',
	version: '1.0.0',
	icon: <NewsIcon />,
	fields: [
		{
			name: 'Title',
			slug: 'title',
			required: true,
			type: 'text',
			placeholder: 'Enter Title',
		},
		{
			name: 'Article URL',
			slug: 'url',
			required: true,
			type: 'text',
			placeholder: 'https://',
		},
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'The description of the Media Citation',
		},
		{
			name: 'Publisher',
			slug: 'publisher',
			required: false,
			type: 'text',
			placeholder: 'Enter Publisher',
		},
		{
			name: 'Publishing Date',
			slug: 'date',
			required: false,
			type: 'date',
			placeholder: 'Select a Date',
		},
		{
			name: 'Author',
			slug: 'author',
			required: false,
			type: 'text',
			placeholder: 'Enter Author',
		},
	],
	info: '',
}
